import './App.css'
import { Routes, Route } from 'react-router-dom'
import Home from './pages/Home'
import { ContentContainer, LayoutContainer } from './styles/Layout.style'
import Header from './components/Header/Header'
import Footer from './components/Footer/Footer'
import About from './pages/About'
import ContactUsPage from './pages/ContactUs'
import Lines from './pages/Lines'
import ConstructionPage from './pages/Construction'
import JoinTeam from './pages/JoinTeam'
import Product from './pages/Product'
import EuphaWorld from './pages/EuphaWorld'
import DoctorDirectory from './pages/DoctorDirectory'

function App() {
  return (
    <LayoutContainer>
      {/* <Header /> */}
      <ContentContainer>
        <Routes>
          <Route path='/' element={<DoctorDirectory />} />
          <Route path='/sobre-nosotros' element={<About />} />
          <Route path='/contacto/contacto' element={<ContactUsPage />} />
          <Route path='/lineas' element={<Lines />} />
          <Route path='/en-construccion' element={<ConstructionPage />} />
          <Route path='/contacto/unete-al-equipo' element={<JoinTeam />} />
          <Route path='/lineas/:lineId/:productId' element={<Product />} />
          <Route path='/eupha-world' element={<EuphaWorld />} />
          <Route path='/helixor-directorio' element={<DoctorDirectory />} />
        </Routes>
      </ContentContainer>
      {/* <Footer /> */}
    </LayoutContainer>
  )
}

export default App
